module.exports = __webpack_public_path__ + "static/media/feature_predictive_modeling.eea24e37.png";